var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiLogoutRtl = function SvgUiLogoutRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.64 10c5.261 0 9.567 4.363 9.653 9.74l.001.164v60.192c0 5.398-4.253 9.815-9.496 9.903L86.64 90H64.621c-1.285 0-2.327-1.069-2.327-2.387 0-1.294 1.005-2.348 2.258-2.385l.069-.001h22.018c2.716 0 4.954-2.266 5-5.041l.002-.09V19.904c0-2.786-2.209-5.081-4.915-5.13H64.622c-1.285 0-2.327-1.07-2.327-2.387 0-1.295 1.005-2.349 2.258-2.386l.069-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.712 72.1 4.646 51.553a2.2 2.2 0 0 1-.485-.763 2.46 2.46 0 0 1 0-1.752c.107-.286.273-.545.485-.763l20.066-20.708a2.423 2.423 0 0 1 3.436-.04c.96.941.978 2.485.04 3.449L12.133 47.4h61.442A2.43 2.43 0 0 1 76 49.834a2.43 2.43 0 0 1-2.425 2.434H12.133l16.055 16.423c.938.963.92 2.508-.04 3.449a2.423 2.423 0 0 1-3.436-.04"
  }))));
};
export default SvgUiLogoutRtl;